import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MapEmbed from '../components/MapEmbed';
import { MapPin, Phone, Mail } from 'lucide-react';
import { company } from '../mock';

export default function OfficePage() {
  const offices = [
    { name: 'Head Office — Surat', addr: '7/33-34, Sharda Sadan, Near Central Bus Stand, Railway Station Road, Surat - 395003, Gujarat, India', phone: company.phone, email: company.email, mapQuery: 'Sharda Sadan, Near Central Bus Stand, Railway Station Road, Surat, Gujarat 395003' },
    { name: 'Forwarding Office — Hazira', addr: '34-A/1, Adani Port Road, Hazira, Choryashi, Surat - 394270, Gujarat, India', phone: company.phone, email: company.email, mapQuery: 'Adani Port Road, Hazira, Choryashi, Surat, Gujarat 394270' }
  ];
  return (
    <>
      <Header />
      <div className="page-hero" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3ODc0OTI0NTd8MA&ixlib=rb-4.1.0&q=85)', paddingTop: '80px' }}>
        <div className="text-center max-w-3xl mx-auto px-6">
          <p className="uppercase text-xs tracking-[0.4em] mb-3 opacity-80">Locations</p>
          <h1 className="text-4xl md:text-6xl font-light" style={{ fontFamily: 'Playfair Display, serif' }}>Our Office</h1>
          <div className="mx-auto w-16 h-[2px] bg-white/70 mt-5" />
        </div>
      </div>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-1 gap-10">
          {offices.map((o, i) => (
            <div key={i} className="grid md:grid-cols-2 gap-6 items-stretch">
              <div className="p-8 border border-[color:var(--line)] rounded-md hover:shadow-lg transition-shadow bg-white">
                <h3 className="text-2xl font-semibold text-[color:var(--brand)] mb-4">{o.name}</h3>
                <div className="space-y-3 text-[color:var(--ink)]">
                  <div className="flex gap-3"><MapPin className="text-[color:var(--brand)] mt-1 shrink-0" size={18} /> <span>{o.addr}</span></div>
                  <div className="flex gap-3"><Phone className="text-[color:var(--brand)] mt-1 shrink-0" size={18} /> <a href={`tel:${company.phoneRaw}`} className="hover:text-[color:var(--brand)] transition-colors">{o.phone}</a></div>
                  <div className="flex gap-3"><Mail className="text-[color:var(--brand)] mt-1 shrink-0" size={18} /> <a href={`mailto:${o.email}`} className="hover:text-[color:var(--brand)] transition-colors">{o.email}</a></div>
                </div>
              </div>
              <MapEmbed query={o.mapQuery} title={o.name.split(' — ')[0]} height={340} />
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}
